import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext } from 'react';
import { useLocalStorage } from '@lib/hooks';
import { Country, Currency, getUserTimeZone, isWidget, Tip } from '@lib/services';
import { CampaignSetup } from '../campaignSetup';
import { ProductType } from '../common';
export const FGdefaultCharity = {
    about: '',
    registration_number: '',
    campaign: ProductType.fridayGiving,
    logo_image: '',
    causes: [],
    selectedCauses: [],
    charity_id: '',
    charity_name: '',
    country: Country.GB,
    currency: Currency.GBP,
    gift_aid: false,
    privacy_policy_url: '',
    tax_receipt: false,
    partner: ''
};
export const getFGDefaultPlan = () => {
    const tz = getUserTimeZone();
    return {
        campaign: CampaignSetup.currentFGCampaign,
        chainCode: '',
        causes: {},
        chainCodeCharity: FGdefaultCharity,
        charity: FGdefaultCharity,
        detectedTimezone: tz,
        fridayGivingAmount: 0,
        selectedCauses: [],
        emailOptIn: true,
        charityEmailOptIn: false,
        timezone: tz !== '' ? tz : 'Europe/London',
        evergiveOptIn: '',
        evergiveDonationAmount: 1000,
        donorDetails: {
            addressLine1: '',
            country: '',
            email: '',
            firstName: '',
            lastName: '',
            houseNumber: '',
            postalCode: '',
            isAddressFromLookup: false
        },
        paymentDetails: {
            giftAid: false,
            taxReceipt: false,
            payFees: true,
            payTip: true,
            tipPercent: Tip.TenPercent,
            tipValue: 0
        },
        isFromCharityLandingPage: false,
        partner: '',
        group: '',
        campaignSource: ''
    };
};
const checkoutFGPlanContext = createContext({
    plan: getFGDefaultPlan(),
    setPlan: (p) => console.log(p),
    resetPlan: () => { },
    setCharity: (c) => console.log(c),
    setCampaignSource: (campaignSource) => console.log(campaignSource)
});
export const useFGCheckoutPlan = () => {
    const result = useContext(checkoutFGPlanContext);
    if (result.plan.campaign !== CampaignSetup.currentFGCampaign) {
        result.resetPlan();
    }
    return result;
};
export const CheckoutFGPlanProvider = ({ children }) => {
    const [plan, setPlan] = useLocalStorage('checkout_fg_plan', getFGDefaultPlan());
    const setCharity = (charity) => {
        const causes = plan.charity.charity_id === charity.charity_id ? plan.causes : {};
        setPlan(Object.assign(Object.assign({}, plan), { charity, causes, selectedCauses: [], campaignSource: '' }));
    };
    const resetPlan = useCallback(() => {
        if (isWidget) {
            setPlan(Object.assign(Object.assign({}, getFGDefaultPlan()), { charity: plan.charity }));
            return;
        }
        setPlan(getFGDefaultPlan());
    }, [setPlan, plan.charity]);
    const setCampaignSource = (campaignSource) => {
        setPlan(Object.assign(Object.assign({}, plan), { campaignSource }));
    };
    const value = {
        plan,
        setPlan,
        resetPlan,
        setCharity,
        setCampaignSource
    };
    return _jsx(checkoutFGPlanContext.Provider, Object.assign({ value: value }, { children: children }));
};
//# sourceMappingURL=data:application/json;base64,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